import IconOptions from './iconSelector'

export * from './src'
export { IconOptions }
